'use client';

import Script from 'next/script';
import { GoogleAnalytics, GoogleTagManager } from '@next/third-parties/google';
import { useConsent } from '@/providers/consent-context';
import OpenAiAdsPixel from './openai_ads_pixel';

const hotjarId = process.env.NEXT_PUBLIC_HOTJAR_ID;
const hotjarVersion = process.env.NEXT_PUBLIC_HOTJAR_SV || '6';

const buildHotjarScript = (siteId, snippetVersion) => `
    (function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${siteId},hjsv:${snippetVersion}};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
`;

export default function ConsentManagedScripts({ googleAnalyticsId, googleTagManagerId }) {
    const { canUseIntegration } = useConsent();

    const shouldLoadGoogleOneTapScript = canUseIntegration('googleOneTap');
    const shouldLoadAnalytics = canUseIntegration('googleAnalytics');
    const shouldLoadTagManager = canUseIntegration('googleTagManager');
    const shouldLoadHotjar = canUseIntegration('hotjar') && hotjarId;
    const shouldLoadOpenAiAdsPixel = canUseIntegration('openaiAdsPixel');

    return <>
        {shouldLoadGoogleOneTapScript && (
            <Script
                id="google-auth-script"
                src="https://accounts.google.com/gsi/client"
                strategy="lazyOnload"
                onLoad={() => {
                    window.dispatchEvent(new Event('mpweb_google_auth_script_loaded'));
                }}
            />
        )}
        {shouldLoadAnalytics && googleAnalyticsId && (
            <GoogleAnalytics gaId={googleAnalyticsId} />
        )}
        {shouldLoadTagManager && googleTagManagerId && (
            <GoogleTagManager gtmId={googleTagManagerId} />
        )}
        {shouldLoadHotjar && (
            <Script
                id="hotjar-script"
                strategy="afterInteractive"
                dangerouslySetInnerHTML={{
                    __html: buildHotjarScript(hotjarId, hotjarVersion)
                }}
            />
        )}
        <OpenAiAdsPixel hasConsent={shouldLoadOpenAiAdsPixel} />
    </>;
}